export var ComparatorShape;
(function (ComparatorShape) {
    ComparatorShape["Segment"] = "segment";
    ComparatorShape["Surface"] = "surface";
})(ComparatorShape || (ComparatorShape = {}));
//# sourceMappingURL=SegmentComparator.js.map